import "./modal.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import React, { useEffect, useState, useReducer } from "react";
import FadeIn from "react-fade-in";
import { useLoading, Rings } from "@agney/react-loading";
import { validate_conditions, validate_variables } from "./Helper_functions";
import "react-datepicker/dist/react-datepicker.css";
import { getworkflowmetadata, get_metadata_info } from "../Api";
import Modal_header from "./Modal_header";
import Modal_footer from "./Modal_footer";
import Modal_left_section from "./Modal_left_section";
import Modal_variables from "./Modal_variables";
import Modal_conditions from "./Modal_conditions";

const Modal = ({
  handleClose,
  show,
  addstep,
  editstep,
  ModalType,
  source_id,
  path,
  triggerdata,
  step_id,
  permissionData
}) => {
  const [isAction, setIsAction] = useState(false);
  const [isApp, setIsApp] = useState(false);
  const [error, setError] = useState(false);
  const [trigger, setTrigger] = useState([]);
  const [metaDataInfo, setMetaDataInfo] = useState(null);
  const [isVariable, setIsVariable] = useState(false);
  const [proceed, setProceed] = useState(false);
  const [variablesData, setVariablesData] = useState([]);
  const [conditionsData, setConditionsData] = useState([]);
  const [modalLoader, setModalLoader] = useState(false);
  const [conditionsLoader, setconditionsLoader] = useState(false);
  const [variablesLoader, setVariablesLoader] = useState(false);
  const [isValidated, setIsValidated] = useState(false);

  const [proceedPermission, setProceedPermission] = useState(true);
  const [permissionMessage, setPermissionMessage] = useState(null);
  const [showPermissionMessage, setShowPermissionMessage] = useState(true);
  // const [sendSMSPermissionMessage, setSendSMSPermissionMessage] = useState(null);

  const cleanUp = () => {
    setModalLoader(true);
    setTrigger([]);
  };

  useEffect(() => {


    if (ModalType.isAction && ModalType.category !== "App") {
      setIsAction(true);
    } else if (ModalType.isAction && ModalType.category == "App") {

      setIsApp(true);
      setIsAction(false);
    } else if (!ModalType.isAction) {
      setIsAction(false);
    }
  }, [
    ModalType.variables,
    ModalType.conditions,
    ModalType.isAction,
    ModalType.category,
  ]);

  useEffect(() => {
    cleanUp();

    if (ModalType.isAction && ModalType.category !== "App") {
      if (ModalType.id) {
        getmetadatainfo(ModalType.id);
      }
    } else if (ModalType.isAction && ModalType.category == "App") {
      if (ModalType.isediting == true) {
        handleClick({ id: ModalType.id });
      }
      getworkflowmetadata()
        .then((data) => {
          if (triggerdata && triggerdata.length > 0) {

            setTrigger(data.Action.App[triggerdata]);
          }
          setModalLoader(false);
        })
        .catch((e) => { })
    } else if (!ModalType.isAction) {
      if (ModalType.isediting == true) {
        handleClick({ id: ModalType.id });
      }
      getworkflowmetadata("StartEvent")
        .then((data) => {
          if (triggerdata && triggerdata.length > 0) {
            setTrigger(data.StartEvent[triggerdata]);
            setModalLoader(false);
          }
        })
        .catch((e) => { })
    }

  }, [
    ModalType.id,
    ModalType.isediting,
    ModalType.isAction,
    ModalType.category,
    triggerdata,
  ]);

  useEffect(() => {
    setPermissionMessage(null);
    setProceedPermission(true);

    if (triggerdata === 'Signals') {
      setPermissionMessage(permissionData.Signals.message);
      if (permissionData.Signals.allowed) {
        setProceedPermission(true);
      } else {
        setProceedPermission(false);
      }
    }
    if (triggerdata === 'Send SMS') {
      setPermissionMessage(permissionData.Sms.message);
      if (permissionData.Sms.allowed) {
        setProceedPermission(true);
      } else {
        setProceedPermission(false);
      }
    }
  }, [triggerdata]);

  function getmetadatainfo(ids) {

    get_metadata_info(ids)
      .then((data) => {
        setMetaDataInfo(data);
        setModalLoader(false);

        // check if variables or conditions are present?
        data.variables && data.variables.length > 0
          ? setIsVariable(true)
          : setIsVariable(false);

        sessionStorage.setItem("metadatainfo", JSON.stringify(data));
        setIsValidated(validate(data));
        setProceed(true);
      })
      .catch((e) => { })
  }

  const variables_data = (var_data) => {

    let variabledata = [];
    var_data.map((obj) => {
      let temp = {
        variableId: obj.variableId,
        value: obj.selectedValue,
        valueToShow: obj.valueToShow,
      };
      variabledata.push(temp);
    });
    sessionStorage.setItem("variablesData", JSON.stringify(var_data));
    var_data && setVariablesData(variabledata);
    setIsValidated(validate(metaDataInfo));
  };

  const condition_data = (cond_data) => {

    cond_data && setConditionsData(cond_data);
    sessionStorage.setItem("conditionsData", JSON.stringify(cond_data));
    setIsValidated(validate(metaDataInfo));
  };

  const handleClick = (e) => {
    getmetadatainfo(e.id);
  };

  const handlevariablesLoader = (e) => {

    setconditionsLoader(e);
  };

  const handleconditionsLoader = (e) => {

    setVariablesLoader(e);
  };

  const validate = (data) => {
    if (data?.variables?.length > 0 && data.conditionSupported == false) {
      return validate_variables(isVariable);
    } else if (data.variables.length > 0 && data.conditionSupported == true) {
      return (
        validate_variables(isVariable) &&
        validate_conditions(conditionsData, data)
      );
    } else {
      return data.serviceName == "IfElseService"
        ? validate_conditions(
          JSON.parse(sessionStorage.getItem("metadatainfo"))
        )
          ? true
          : false
        : true;
    }

    // return validate_variables(variablesData,isVariable) && validate_conditions(conditionsData, metaDataInfo) ?true:false;
  };

  const handleProceed = (e) => {
    e.preventDefault();
    if (isValidated) {
      ModalType.isediting != true
        ? addstep(
          variablesData,
          conditionsData,
          ModalType,
          metaDataInfo.id,
          path,
          source_id
        )
        : editstep(variablesData, conditionsData, step_id, metaDataInfo.id);

      sessionStorage.removeItem("variablesData");
      sessionStorage.removeItem("conditionsData");
      handleClose(variablesData, conditionsData);
    }
  };

  const ResetModal = (variablesData, conditionsData) => {
    sessionStorage.removeItem("variablesData");
    sessionStorage.removeItem("conditionsData");
    handleClose();
  };

  const messageBar = (permissionMessage) => {
    if (permissionMessage) {
      return (
        showPermissionMessage && <div style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
          <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>

          <span onClick={() => {
            setShowPermissionMessage(false)
          }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
        </div>
      )
    }
  }

  return (
    //<div className={show?"modal display-block ": "modal display-none "}>
    <div
      className="modal fadeIn"
      style={show ? { display: "block", zIndex: 9999 } : { display: "none" }}
      role="dialog"
      id="kwModal"
    >
      {/* modal start */}

      <FadeIn>
        <div className="modal-dialog modal-dialog-centered kw-workflow-modal" role="document">
          <div className="modal-content">
            <Modal_header
              isAction={isAction}
              isApp={isApp}
              reset_modal={ResetModal}
            ></Modal_header>
            <form
              role="form"
              id="newModalForm"
              onSubmit={(e) => handleProceed(e)}
            >
              {
                messageBar(permissionMessage)
              }
              <div className="modal-body">
                {!isAction ? (
                  <>
                    {modalLoader ? (
                      <Content></Content>
                    ) : (
                      <>
                        {conditionsLoader || variablesLoader ? (
                          <Content></Content>
                        ) : (
                          <>
                            <Modal_left_section
                              handleClick={handleClick}
                              trigger={trigger}
                              id={ModalType.id}
                            ></Modal_left_section>

                            <div className="rightsection">
                              <div id="kw-wrapper">
                                {isVariable && (
                                  <Modal_variables
                                    // error={error}
                                    metaDataInfo={metaDataInfo}
                                    variables_data={variables_data}
                                    ModalType={ModalType}
                                    handlemodalLoader={handlevariablesLoader}
                                  ></Modal_variables>
                                )}
                                <br />
                                {/* Conditions filters */}
                                {metaDataInfo &&
                                  metaDataInfo.conditionSupported === true && (
                                    <Modal_conditions
                                      metaDataInfo={metaDataInfo}
                                      ModalType={ModalType}
                                      condition_data={condition_data}
                                      handlemodalLoader={handleconditionsLoader}
                                    ></Modal_conditions>
                                  )}
                              </div>
                            </div>
                          </>
                        )}
                        {/* Left Section of the modal */}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {modalLoader ? (
                      <Content></Content>
                    ) : (
                      <>
                        {conditionsLoader || variablesLoader ? (
                          <Content></Content>
                        ) : (
                          <div id="kw-wrapper">
                            {isVariable && (
                              <Modal_variables
                                // error={error}
                                metaDataInfo={metaDataInfo}
                                variables_data={variables_data}
                                ModalType={ModalType}
                                handlemodalLoader={handlevariablesLoader}
                              ></Modal_variables>
                            )}
                            <br />
                            {/* Conditions filters */}
                            {metaDataInfo &&
                              metaDataInfo.conditionSupported === true && (
                                <Modal_conditions
                                  metaDataInfo={metaDataInfo}
                                  ModalType={ModalType}
                                  condition_data={condition_data}
                                  handlemodalLoader={handleconditionsLoader}
                                ></Modal_conditions>
                              )}
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              {
                proceedPermission && <Modal_footer
                  proceed={proceed}
                  ModalType={ModalType}
                  isVariable={isVariable}
                  isValidated={isValidated}
                  conditionSupported={
                    metaDataInfo && metaDataInfo.conditionSupported
                  }
                ></Modal_footer>
              }

            </form>
          </div>
        </div>
      </FadeIn>
    </div>
  );
};

export function Content() {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Rings width="100" height="100" />,
    loaderProps: {},
  });

  return <section {...containerProps}>{indicatorEl}</section>;
}

export default Modal;
